import * as React from "react";
import type { SVGProps } from "react";
const SvgDots = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16px"
    height="16px"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#2E2040"
      d="M14.5 16a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-4 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m11 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M29 8v16a2 2 0 0 1-2 2H10.375L6.3 29.52l-.011.009C5.929 29.834 5.472 30 5 30a2.02 2.02 0 0 1-1.691-.926A2 2 0 0 1 3 28V8a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2m-2 0H5v20l4.346-3.75A1 1 0 0 1 10 24h17z"
      stroke={props.color}
    />
  </svg>
);
export default SvgDots;
